import React, { PureComponent } from 'react'

import './../styles/FilterRadius.css'

class Radius extends PureComponent {
  normalizeRadius = (radius, lowerLimit, upperLimit)  => {
    if (!upperLimit) {
      return (radius > lowerLimit) ? lowerLimit : radius
    } else {
      return (radius >lowerLimit && radius <= upperLimit) ? upperLimit : radius
    }
  }

  handleRadiusChange = (e) => {
    this.props.setFiltersData(e.target.value, 'radiusFilter')
  }

  handleRadiusClear = (e) => {
    this.props.setFiltersData(false, 'radiusFilter')
  }

  render () {
    let { radius } = this.props

    radius = parseInt(radius, 10)

    radius = this.normalizeRadius(radius, 0, 5)
    radius = this.normalizeRadius(radius, 5, 10)
    radius = this.normalizeRadius(radius, 10, 20)
    radius = this.normalizeRadius(radius, 20, 30)
    radius = this.normalizeRadius(radius, 30, 50)
    radius = this.normalizeRadius(radius, 50, 75)
    radius = this.normalizeRadius(radius, 75, 100)
    radius = this.normalizeRadius(radius, 100, 150)
    radius = this.normalizeRadius(radius, 150, 200)
    radius = this.normalizeRadius(radius, 200, 300)
    radius = this.normalizeRadius(radius, 300, false)

    return (
      <div id="filter-radius">
        <div id="uiName">
          <span id="btnClear" onClick={this.handleRadiusClear}>
            <span id="icon"></span>
          </span>
          {this.props.place}
        </div>
        <div id="selectWrapper">
          <select value={radius} onChange={this.handleRadiusChange} >
            <option value="5">5 km</option>
            <option value="10">10 km</option>
            <option value="20">20 km</option>
            <option value="30">30 km</option>
            <option value="50">50 km</option>
            <option value="75">75 km</option>
            <option value="100">100 km</option>
            <option value="150">150 km</option>
            <option value="200">200 km</option>
            <option value="300">300 km</option>
          </select>
        </div>
      </div>
    )
  }
}

export default Radius


// WEBPACK FOOTER //
// ./src/components/parts/Radius.js